module.exports = __webpack_public_path__ + "images/emoji/top.6fca2aec92e284379457.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/top.png
// module id = U+vD
// module chunks = 24